// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M5.05 8.5V4.4C5.05 3.77 5.57 3.25 6.2 3.25C6.83 3.25 7.35 3.77 7.35 4.4V7.2',
  'M7.35 4.4V2.75C7.35 2.12 7.87 1.6 8.5 1.6C9.13 1.6 9.65 2.12 9.65 2.75V7.2',
  'M9.65 4.1C9.65 3.46 10.16 2.95 10.8 2.95C11.44 2.95 11.95 3.46 11.95 4.1V7.75',
  'M11.95 6.25C11.95 5.62 12.46 5.1 13.1 5.1C13.73 5.1 14.25 5.62 14.25 6.25V9.15C14.25 12.35 12.3 14.4 9.3 14.4H8.1C6.4 14.4 5.25 13.85 4.1 12.7L2 10.6C1.47 10.07 1.47 9.21 2 8.68C2.53 8.15 3.39 8.15 3.92 8.68L4.39 9.15C4.64 9.4 5.05 9.22 5.05 8.87V8.5',
];
